import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnergyScaleHouse = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 249 338",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    " }), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient",
			x1: 126.7,
			y1: -3.62,
			x2: 124.3,
			y2: 337.78,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#00b500"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .19,
					stopColor: "#51dd00"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .36,
					stopColor: "#c3ef0c"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .54,
					stopColor: "#fff200"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .71,
					stopColor: "#ffbd03"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .86,
					stopColor: "#ff8b00"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fc0000"
				})
			]
		})] }),
		/* @__PURE__ */ _jsx("g", {
			id: "Ebene_2",
			"data-name": "Ebene 2",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Ebene_1-2",
				"data-name": "Ebene 1",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M249.79,109.4c-3.76.47-7.13,2.36-8.43,5.51a314.47,314.47,0,0,0-29.61,42.6c-10.89,18.67-20,38.1-23.49,58.59-2.34,13.54-1.26,29,8.79,40.53,10.27,11.85,26.72,17,43.89,18.55V320.6h-113V168.49c0-4.8-4.93-8.92-11-8.92H41.86l33.75-22.41,109.53-72.7,64.65-42.91V0a15.09,15.09,0,0,0-5.51,2.28L187.8,39.78,78.27,112.48,5.6,160.72,3.37,162.2c-7.62,5.06-1.15,15.09,7.8,15.09h94.61V329.4c0,4.8,4.94,8.92,11,8.92h133Zm-8.85,148-1.27-.15c-1.63-.21-3.24-.49-4.85-.8-2-.4-4.08-.91-6.06-1.49-.17-.08-2.09-.74-2.63-.95-1.2-.49-2.37-1-3.51-1.61-.39-.2-1.35-.76-1.87-1.07s-1-.7-1.51-1.06c-.78-.58-1.51-1.21-2.23-1.84-.24-.21-.48-.44-.71-.67l-.14-.15a30.09,30.09,0,0,1-3.2-4.36c-.15-.23-.28-.47-.41-.7-.43-.9-.8-1.81-1.14-2.73a35.09,35.09,0,0,1-1.48-5.25c0-.19-.08-.39-.11-.59s0-.19,0-.27c-.15-1.1-.23-2.21-.3-3.32a58,58,0,0,1,.27-9.32l31.19,26.56Zm0-51.28v22.11l-27.55-23.46c1.34-4.3,2.93-8.56,4.67-12.77,1-2.37,2-4.72,3.11-7.06l19.77,16.61Zm0-23.84L228,171.49c3.58-6.47,7.46-12.84,11.55-19.11.44-.68.9-1.36,1.35-2Z"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgEnergyScaleHouse);
export default ForwardRef;
